module.exports = __webpack_public_path__ + "static/media/25.2a0f6d35.jpg";